export async function prepareApolloAuthRetry(operation, refreshSession) {
  const context = operation.getContext();
  if (context.authRetryAttempted === true) return false;

  const headers = context.headers || {};
  const authorization = headers.Authorization || headers.authorization || '';
  const rejectedAccessToken = authorization.replace(/^Bearer\s+/i, '') || null;
  operation.setContext({ authRetryAttempted: true });
  const user = await refreshSession({
    reason: 'http_401',
    rejectedAccessToken,
  });
  const normalizedHeaders = Object.fromEntries(
    Object.entries(headers).filter(([key]) => key.toLowerCase() !== 'authorization'),
  );
  operation.setContext({
    headers: {
      ...normalizedHeaders,
      Authorization: `Bearer ${user.access_token}`,
    },
  });
  return true;
}
